/**
 * The ask-AI audience filter's one typed failure (C09-5): the AI call failed
 * or ran past the request deadline, which Nest owns. Nest sends it as the
 * error `code`; the filter panel words it from the UI catalog
 * (`creation.askAi.errorUnavailable`, en/es/fr/pt).
 */
export const ASK_AI_FILTER_UNAVAILABLE_CODE = "ask_ai_filter_unavailable";
